import React, { useState } from "react";
import Sidebar from "../components/Sidebar/index";

const DefaultLayout = ({ children, isLogin }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="bg-boxdark-2 text-bodydark">
      {/* <!-- ===== Page Wrapper Start ===== --> */}
      <div className="flex h-screen overflow-hidden">
        {/* <!-- ===== Sidebar Start ===== --> */}
        {!isLogin && (
          <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        )}
        {/* <!-- ===== Sidebar End ===== --> */}

        {/* <!-- ===== Content Area Start ===== --> */}
        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          {/* <!-- ===== Main Content Start ===== --> */}
          <main className="h-full">
            <div
              className={`mx-auto ${
                isLogin ? "" : "p-4 md:p-6 2xl:p-8"
              } h-full`}
            >
              {children}
            </div>
          </main>
          {/* <!-- ===== Main Content End ===== --> */}
        </div>
        {/* <!-- ===== Content Area End ===== --> */}
      </div>
      {/* <!-- ===== Page Wrapper End ===== --> */}
    </div>
  );
};

export default DefaultLayout;
